import {useMutation, useQuery, useQueryClient} from "react-query";
import {getMember, requestJoinAppointment} from "../../api/AlfyApiClient";
import {useRecoilValue} from "recoil";
import {userState} from "../user/userAtom";
import {QUERY_KEYS} from "../query-keys";
import {JoinAppointmentRequest} from "../../models/request/member";

const STALE_TIME = {
    MEMBER: 1000 * 60 * 5,
}

export const useFetchMemberMe = (appointmentId: string) => {
    const user = useRecoilValue(userState);
    const { data, isLoading } = useQuery([QUERY_KEYS.MEMBER, appointmentId],
        async () => {
            return await getMember(appointmentId)
        },
        {
            enabled: user !== null && appointmentId.length > 0,
            staleTime: STALE_TIME.MEMBER,
            onError: (error) => {
                console.error(error)
            }
        })
    return { data: data ?? null, isLoading } // user가 null이면 data(member)를 null로 반환
}

export const useJoinAppointment = () => {
    const queryClient = useQueryClient()
    return useMutation(async (request: JoinAppointmentRequest) => {
        return await requestJoinAppointment(request)
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries(QUERY_KEYS.MEMBER)
        }
    })
}